<template>
  <div class="home">
    <navbar />

    <b-container fluid>
      <b-row class="py-5">
        <b-col class="text-center">
          <img
            class="mb-2"
            height="150"
            src="../assets/logo.png"
            alt="Codingbee logo"
          />
          <h1>Programming Bootcamp</h1>
          <div class="mb-4">
            Learn Key Programinng Concepts with Block-based Programming
          </div>
          <b-button
            class="mr-2 mb-2"
            to="/foundation"
            variant="warning"
            size="lg"
            pill
          >
            Get Started
          </b-button>
          <b-button
            class="mb-2"
            href="https://codingbee.my"
            variant="outline-secondary"
            size="lg"
            pill
          >
            Programming Classes
          </b-button>
          <b-button to="/playground" variant="link-secondary" size="lg">
            Playground
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col class="text-center">
          <h2>Available Courses</h2>
        </b-col>
      </b-row>

      <b-row align-h="center" class="mb-5">
        <b-col sm="4" class="mb-4">
          <b-card
            no-body
            class="overflow-hidden"
            style="max-width: 540px;"
            @click="onClickCourse('foundation')"
          >
            <b-row no-gutters>
              <b-col md="6">
                <b-card-img
                  :src="require('../static/blockly.png')"
                  alt="Blockly"
                ></b-card-img>
              </b-col>
              <b-col md="6">
                <b-card-body title="Foundation">
                  <b-card-text>
                    Learn key concepts of programming such as variables, loops
                    and conditionals.
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col sm="4" class="mb-4">
          <b-card
            no-body
            class="overflow-hidden"
            style="max-width: 540px;"
            @click="onClickCourse('video-course')"
          >
            <b-row no-gutters>
              <b-col md="6">
                <b-card-img
                  :src="require('../static/youtube.png')"
                  alt="Blockly"
                ></b-card-img>
              </b-col>
              <b-col md="6">
                <b-card-body title="Video Course">
                  <b-card-text>
                    Series of videos explaning various concepts of programming
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>

        <b-col sm="4">
          <b-card
            no-body
            class="overflow-hidden"
            style="max-width: 540px;"
            @click="onClickCourse('foundation-challenges')"
          >
            <b-row no-gutters>
              <b-col md="6">
                <b-card-img
                  :src="require('../static/challenge.jpg')"
                  alt="Blockly"
                ></b-card-img>
              </b-col>
              <b-col md="6">
                <b-card-body title="Foundation Challenges">
                  <b-card-text>
                    Challenge questions to test your core concepts of
                    programming
                  </b-card-text>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <app-footer />
  </div>
</template>

<script>
import AppFooter from "@/components/AppFooter.vue";
import Navbar from "@/components/Navbar.vue";

export default {
  name: "home",

  components: {
    AppFooter,
    Navbar
  },

  methods: {
    onClickCourse(course) {
      this.$router.push(course);
    }
  }
};
</script>
